import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { inr } from "@/lib/ownerApi";
import ReconBatchDetail from "./ReconBatchDetail";

const H = ["Batch", "Excel fees", "Excel collected", "Eligible (revised)", "Collected (revised)", "Outstanding", "Website fees", "Website collected", "Matched", "Historical-only", "Website-only", "Duplicates / same name", "Differences", "Leavers / corrected"];

const Row = ({ b, open, toggle }) => {
  const n = (a) => a.length;
  return (
    <tr className="hover:bg-stone-50 cursor-pointer" onClick={toggle} data-testid={`recon-batch-${b.batch}`}>
      <td className="px-3 py-2 font-semibold whitespace-nowrap">{open ? <ChevronDown className="inline h-4 w-4" /> : <ChevronRight className="inline h-4 w-4" />} {b.batch}{b.checks.length > 0 && <span className="ml-1 text-amber-600">●</span>}</td>
      <td className="px-3 text-right">{inr(b.excel.fees)}</td><td className="px-3 text-right text-emerald-800">{inr(b.excel.collected)}</td>
      <td className="px-3 text-right font-semibold" data-testid={`recon-rev-eligible-${b.batch}`}>{inr(b.revised?.eligible ?? b.excel.fees)}</td><td className="px-3 text-right font-semibold text-emerald-800">{inr(b.revised?.collected ?? b.excel.collected)}</td><td className="px-3 text-right text-amber-800">{inr(b.revised?.outstanding ?? b.excel.balance)}</td>
      <td className="px-3 text-right">{inr(b.website.fees)}</td><td className="px-3 text-right">{inr(b.website.collected)}</td>
      <td className="px-3 text-right">{n(b.matched) + n(b.other_batch)}<span className="text-stone-400">/{b.excel.students}</span></td>
      <td className="px-3 text-right">{n(b.historical_only)}</td><td className="px-3 text-right">{n(b.website_only)}</td>
      <td className="px-3 text-right">{n(b.duplicates) + n(b.ambiguous)}</td><td className="px-3 text-right">{n(b.differences) + n(b.overlaps)}</td>
      <td className="px-3 text-right">{n(b.leavers)}</td>
    </tr>
  );
};

export default function ReconBatchTable({ batches, decisions, onDecide, twice }) {
  const [open, setOpen] = useState(null);
  return (
    <section className="space-y-3" data-testid="recon-batches">
      <h3 className="font-bold text-stone-900">Reconciliation by batch</h3>
      <p className="text-xs text-stone-500">Tap a batch to see matched records, historical-only students, website-only students, duplicates, leavers and differences. ● = Excel check notes.</p>
      <div className="overflow-x-auto rounded-xl border border-stone-200 bg-white">
        <table className="min-w-full text-sm">
          <thead className="bg-stone-100 text-stone-600"><tr>{H.map((h, i) => <th key={h} className={`px-3 py-2 font-semibold whitespace-nowrap ${i ? "text-right" : "text-left"}`}>{h}</th>)}</tr></thead>
          <tbody className="divide-y divide-stone-100">
            {batches.map((b) => (
              <React.Fragment key={b.batch}>
                <Row b={b} open={open === b.batch} toggle={() => setOpen(open === b.batch ? null : b.batch)} />
                {open === b.batch && <tr><td colSpan={H.length} className="p-0"><ReconBatchDetail b={b} decisions={decisions} onDecide={onDecide} /></td></tr>}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      {twice?.length > 0 && <p className="text-sm text-amber-800" data-testid="recon-twice">Website students matched by more than one Excel row: {twice.map((t) => `${t.website.name} (${t.website.roll_number}) ← ${t.excel_refs.join(", ")}`).join("; ")}</p>}
    </section>
  );
}
